import React from 'react'
import { Exception } from './styles'

export default function Page404() {
  return <Exception type="404" desc="Looks like you're lost" redirect="/" />
}
